import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@material-ui/core/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import ScheduleIcon from '@mui/icons-material/Schedule';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import pageimg from './images/attendance.png';


const headCells = [


 
  { id: 'tc_type', numeric: false, label: 'Master Type' },
{ id: 'tc_title', numeric: false,  label: 'Title' },
{ id: '', numeric: false,  label: '' },

  
  
  ]
  
  
 

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
  
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Trsuclassandyear extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Trustclassdata:[],tcid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],tc_type:'',
	 
	  order:'desc' ,orderBy:'',titles:'',searchtitle:'',searchtype:'',mastertypes:'',searchcustomer:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Trustclassdata:[]
    });
	
//this.componentDidMount();  
}
	
componentDidUpdate() {
	
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}


componentWillMount() { 
localStorage.setItem("pageactive",3)
}

	componentDidMount() {
	

	 
		
	
	
	document.title = "MM Coching Center - Trust,Class and Year Management";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	

	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
 
} 



handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
}   


myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_title='+this.state.titles+'&tc_type='+this.state.mastertypes+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Trustclassdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
	
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Trustclassdata:[],totaldata:0});
		   
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      trustDelete(tcid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('tc_id',tcid)
	 	   
	formData.append('userid',localStorage.getItem("MMCuserid"))
	
	
	 axios.post(Serverurl+"ajaxtrustandclass.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }
	  
	  
	  
      Trustaddbox(val){
        this.setState({ tcid: val });  
  
         setTimeout(() => this.refs.AddTrustbox.handleClickOpen(),500);

      }






      Markasisdefault(tcid,type){  
	
let r = window.confirm("Do you really want to Mark As default?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','marksasdefault')
	 formData.append('tc_id',tcid)
	 formData.append('type',type)  
	formData.append('userid',localStorage.getItem("MMCuserid"))
	
	
	 axios.post(Serverurl+"ajaxtrustandclass.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }













render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   <div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>Master</h2>
</div></div>
<div className="searchmaster">
	<ul>
	<li> <p> <FormControl  className="stadrp" >
       
        <Select
          native
		  variant="outlined"
            margin="normal"
         value={this.state.mastertypes}
          onChange={this.myChangeHandler}
        name='mastertypes'
         id='mastertypes'>
		 
          <option value={0}>Select Type</option>
		  <option value={1}>Trust</option>
		  <option value={2}>Class</option>
		  <option value={3}>Year</option>
		  
          
        </Select>
      </FormControl>
		  
		   </p> </li>
	<li><p><TextField  
            //variant="outlined"
            margin="normal"
            
            fullWidth
			value={this.state.titles}
            id="titles"
           variant="outlined"
            name="titles" onChange={this.myChangeHandler}
          
			placeholder="Title"
           
			
          />
		  </p></li>
		  
		  
		 
		   <li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmPrimarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> &nbsp;<Button variant="contained" onClick={()=>{this.Trustaddbox(0)}} className="frmsecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p></li> 

		  </ul>
		  
		 </div>


   


<AddTrustbox ref="AddTrustbox" id={this.state.tcid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Trustclassdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Trustclassdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.type}</TableCell>
<TableCell>{item.tc_title}</TableCell>

<TableCell align="left">
<div className="actionbtns">



<Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.Trustaddbox(item.tc_id)}} endIcon={<EditIcon />}>
Edit
</Button> 

{(item.tc_type==="3" && item.yearcnt==="0" )&&(

 <Button variant="contained" className="admsndisablebtn" onClick={()=>{this.trustDelete(item.tc_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>)}
{(item.tc_type==="2" && item.clscnt==="0" )&&(

 <Button variant="contained" className="admsndisablebtn" onClick={()=>{this.trustDelete(item.tc_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>)}

{(item.tc_type==="1" && item.trustcnt==="0" )&&(

 <Button variant="contained" className="admsndisablebtn" onClick={()=>{this.trustDelete(item.tc_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>)}




 </div>
 

 </TableCell>
 <TableCell>
 {(item.tc_type==="3" && item.tc_isdefault==="0") && (

 <Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.Markasisdefault(item.tc_id,1)}}  endIcon={<ScheduleIcon />}>
Current year
 </Button>
 
 )}
  {(item.tc_type==="3" && item.tc_isdefault==="1") && (

 <Button variant="contained" className="admsndisablebtn"  endIcon={<ScheduleIcon />}>
Cur
 </Button>
 
 )}
 
   {(item.tc_type==="3" && item.tc_isregistered==="0") && (

 <Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.Markasisdefault(item.tc_id,2)}}  endIcon={<ScheduleIcon />}>
Register year
 </Button>
 
 )}
    {(item.tc_type==="3" && item.tc_isregistered==="1") && (

 <Button variant="contained" className="admsndisablebtn"   endIcon={<ScheduleIcon />}>
Reg
 </Button>
 
 )}
</TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="3">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    </div>

 </React.Fragment> 

 
 
  );
}
}


export  class  AddTrustbox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,type:'',title:'',tc_id:0,errormessage:'',erropen:false,adrs:'',phone:'',gstin:'',
	  }
      
  }
  
  
  

  
 Trustgetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      tc_id:resp.data[0].tc_id,
	        type: resp.data[0].tc_type,
	  title: resp.data[0].tc_title,
adrs:resp.data[0].td_address,phone:resp.data[0].td_phone,gstin:resp.data[0].td_gstno,
 

      
      
    
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  title:'',
	 
	 type:'',
	 
	 tc_id:0
	
	 
	  }); 
 }
  
    }

   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  title:'', adrs:'',phone:'',gstin:'',
     errormessage:'',erropen:false,
	  });
		this.Trustgetdata();
		//this.onloadclassbind();


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val});
  

}

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleClose = (e) => {
	
	
 let type = this.state.type;
 let title = this.state.title;
let adrs = this.state.adrs;
let phone = this.state.phone;
let gstin = this.state.gstin;
if(type==="")
{
	
	this.setState({errormessage:"Please Select Type ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(type==="1")
{	if(adrs==="")
	{				
		this.setState({errormessage:"Please Enter Address ",erropen:true});
	        window.scrollTo({top: 0 })
			return false;	
	}
	if(phone==="")
	{				
		this.setState({errormessage:"Please Enter Phone No. ",erropen:true});
	        window.scrollTo({top: 0 })
			return false;	
	}
	if(gstin==="")
	{				
		this.setState({errormessage:"Please Enter GSTIN",erropen:true});
	        window.scrollTo({top: 0 })
			return false;	
	}
}






   var formData = new FormData();
  
  
   if(this.state.tc_id==0)
	  {
		  formData.append('tc_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('tc_id',this.state.tc_id)
		
          }
	  
	  
	  
	  
	 
        formData.append('action','insertorupdate') 
		formData.append('tc_type',type)
		formData.append('tc_title',title)
			formData.append('td_address',adrs)
		formData.append('td_phone',phone)
		formData.append('td_gstno',gstin)
		
		
		
		formData.append('userid',localStorage.getItem("MMCuserid"))
		  
		axios.post(Serverurl+"ajaxtrustandclass.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({errormessage:"Title Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose}  maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Master</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
			<p><span className="validation">*</span> Type</p>
		<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.type}
		onChange={this.myChangeHandler}
		name='type'
		id='type'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={1}>Trust</option>
		<option value={2}>Class</option>
<option value={3}>Year</option>			
		</Select>
		</FormControl></p><p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="title" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.title}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
		
		{this.state.type==="1" && (<React.Fragment>
		
		<p> <span className="validation">*</span> Phone No.</p>
	
	<p><TextField name="phone" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.phone}
			 
			 
			  inputProps={{tabIndex: "3",maxLength:12}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
		
		
		
			<p> <span className="validation">*</span> GSTIN</p>
	
	<p><TextField name="gstin" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.gstin}
			 
		
			  inputProps={{tabIndex: "4",maxLength:15}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
		<p> <span className="validation">*</span> Address</p>
	
	<p><TextField name="adrs" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.adrs} multiline rows="3"
			 
		
			  inputProps={{tabIndex: "5",}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
		
		</React.Fragment>)}		
	
			  
		
 
		
       <div className="actionbtns">

<div className="cancelbtn">	  
        <Button onClick={this.handleClickOpen} color="secondary">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
	</div>		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  